module.exports = __webpack_public_path__ + "static/media/open-america-rewards-logo.c7d02663.png";